export default __webpack_public_path__ + "static/media/bulletin-bkg-img.21075acf.png";